/**
 * Extracts folder ID from URL pathname
 * @param pathname - The URL pathname (defaults to window.location.pathname)
 * @returns The folder ID if found, empty string otherwise
 */
export function getFolderIdFromURL(pathname?: string): string {
  if (typeof window === "undefined") return "";
  const path = pathname || window.location.pathname;
  const match = path.match(/\/folder\/([a-f0-9]{24})/i);
  return match ? match[1] : "";
}
